module.exports = __webpack_public_path__ + "assets/5bd8baed8972572857269f8d63442da0.png";